<template>
    <v-text-field
            :disabled="disabled"
            :rules="rules"
            :label="label"
            @input="change"
            ref="inputtext"
            type="number"
            :min="min"
            :max="max"
            :step="step"
            :maxlength="maxlength"
            :value="value"

    >
    </v-text-field>
</template>

<script>
export default {
  name: 'IgTextField',
  props: {
    value: {
      type: Number,
      default: 100,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    rules: {
      type: Array,
      default: () => {
        return []
      },
      required: false
    },
    label: {
      type: String,
      default: '',
      required: true
    },
    status: {
      type: Boolean,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    maxlength: {
      type: Number,
      required: true
    }

  },
  watch: {
    value (val) {
      this.$refs.inputtext.lazyValue = val
    },
    status (val, oldval) {
      if (val && !oldval) { this.$refs.inputtext.lazyValue = '' }
      this.internalData = ''
    }
  },
  mounted () {
    this.$refs.inputtext.lazyValue = this.value
  },
  data () {
    return {
      internalData: this.value
    }
  },
  methods: {
    change (val) {
      this.internalData = parseInt(val)
      this.$emit('input', this.internalData)
    }
  }
}
</script>
